import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'
import { onMounted } from '@vue/runtime-core'
import Header from '../components/Header.vue'
import Partners from '../components/Partners.vue'
import Features from '../components/Features.vue'
import Architecture from '../components/Architecture.vue'
import MoreSection from '../components/More.vue'
import TradingData from '@/components/TradingData.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

// This starter template is using Vue 3 <script setup> SFCs
// Check out https://v3.vuejs.org/api/sfc-script-setup.html#sfc-script-setup

const scrollTop = ref(0)
const windowWidth = ref(document.documentElement.offsetWidth)

onMounted(() => {
  window.addEventListener('scroll', () => {
    scrollTop.value = document.documentElement.scrollTop
  })

  window.addEventListener('resize', () => {
    windowWidth.value = document.documentElement.offsetWidth
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header, { "scroll-top": scrollTop.value }, null, 8, ["scroll-top"]),
    _createVNode(Partners, { "window-width": windowWidth.value }, null, 8, ["window-width"]),
    _createVNode(TradingData),
    _createVNode(Features, { "scroll-top": scrollTop.value }, null, 8, ["scroll-top"]),
    _createVNode(Architecture, { "window-width": windowWidth.value }, null, 8, ["window-width"]),
    _createVNode(MoreSection)
  ], 64))
}
}

})